<template>
  <div
    class="vb-exercise-write"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-if="data.question"
  >
    <div class="vb-exercise-write-question">
      {{ data.question }}
    </div>
    <div
      class="vb-exercise-write-answer"
      :class="{ answered: !!answer }"
    >
      <textarea
        v-model="answer"
        :readonly="!!data.example"
        @input="answerQuestion"
      ></textarea>
    </div>
  </div>
  <div
    class="vb-exercise-write-empty"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-else
  >
    Exercise write
  </div>
</template>
<script>
  export default {
    name: 'vb-exercise-write',
    props: {
      data: {
        required: true
      },
      path: {
        required: true
      },
      draggable: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    },
    data () {
      return {
        answer: '',
        timeout: null
      }
    },
    methods: {
      answerQuestion () {
        if (this.timeout)
          clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          this.$emit('answer', {
            prop: 'answer',
            value: this.answer,
            path: this.path
          })

          this.timeout = null
        }, 1500)
      }
    },
    watch: {
      data () {
        this.answer = this.data.answer
      }
    },
    beforeMount () {
      this.answer = this.data.answer
    }
  }
</script>
<style lang="scss" scoped>
  .vb-exercise-write {
    font-size: 13px ;
    // font-size: clamp(0em, 0.2em + 1vw, 1em);
    text-align: left;

    &-question {
      color: #670000;
      border: 2px solid #ffaa00;
      border-radius: 10px;
      font-weight: 600;
      padding: 10px 15px;
    }

    &-answer {
      background-color: #d8d8d8;
      margin-top: 10px;
      border-radius: 10px;
      padding: 5px 10px;

      &.answered {
        background-color: #efdba4;
        color: #3e3e3e;
      }

      textarea {
        background-color: transparent;
        border: none;
        width: 100%;
        height: 46px !important;
        resize: none;

        &:focus {
          outline: none;
        }
      }
    }

    &.selected {
      border: .2rem dashed red;
    }
  }

  .vb-exercise-write-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    margin: .5rem;
    height: 2rem;
    border: .2rem dashed brown;

    &.selected {
      border: .2rem dashed red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookExerciseWrite.vue